<template>
  <div>
    <v-layout row wrap fill-height justify-center pt-5>
      <v-flex xs11 lg11>
        <v-card class="rounded-lg">
          <v-card-text class="pa-2">
            <v-layout row wrap justify-center ma-0 pa-2>
              <v-container>
                <b>{{ $t("consentlist.Specifysearchconditions") }}</b>
                <br />
                <v-form ref="form">
                  <v-layout row wrap justify-center align-baseline mb-6>
                    <v-flex xs9 lg3 pa-2>
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                        color="#077893"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            hide-details
                            color="#077893"
                            outlined
                            dense
                            clearable
                            v-model="FromDate"
                            :label="$t('consentlist.submission')"
                            persistent-hint
                            append-icon="mdi-calendar-outline"
                            v-bind="attrs"
                            @blur="date = parseDate(FromDate)"
                            v-on="on"
                            @click:clear="ToDate = ''"
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          hide-details
                          locale="TH"
                          color="#077893"
                          v-model="date"
                          no-title
                          @input="menu1 = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                        color="#077893"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            hide-details
                            color="#077893"
                            outlined
                            dense
                            clearable
                            v-model="ToDate"
                            :label="$t('consentlist.to')"
                            persistent-hint
                            append-icon="mdi-calendar-outline"
                            v-bind="attrs"
                            @blur="date2 = parseDate2(ToDate)"
                            v-on="on"
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          hide-details
                          locale="TH"
                          color="#077893"
                          v-model="date2"
                          no-title
                          @input="menu2 = false"
                          :min="FromDate"
                          :max="TodateMax"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-select
                        hide-details
                        color="#077893"
                        v-model="SourceStatus"
                        :items="$t('email.statusUpload')"
                        :label="$t('petition.text14')"
                        clearable
                        dense
                        outlined
                        append-icon="mdi-format-list-bulleted-type"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-select
                        hide-details
                        color="#077893"
                        append-icon="mdi-card-text-outline"
                        :items="ItemPolicy"
                        item-value="PolicyId"
                        item-text="Title"
                        v-model="policyID"
                        :label="$t('dashboard.policy')"
                        clearable
                        dense
                        outlined
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-baseline mt-n6 mb-6>
                    <v-flex xs9 lg6 pa-2>
                      <v-text-field
                        hide-details
                        append-icon="mdi-account-outline"
                        :label="$t('NewUpdate.Name')"
                        dense
                        outlined
                        v-model="name"
                        color="#077893"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-select
                        hide-details
                        color="#077893"
                        append-icon="mdi-card-text-outline"
                        :items="ItemConsentGeneral"
                        item-value="ConsentId"
                        item-text="HeaderConsent"
                        v-model="consentID"
                        :label="$t('Toolbar.consent')"
                        clearable
                        dense
                        outlined
                      ></v-select>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-select
                        hide-details
                        color="#077893"
                        append-icon="mdi-card-text-outline"
                        :items="ItemConsentGroup"
                        item-value="GroupId"
                        item-text="GroupName"
                        v-model="groupID"
                        :label="$t('consentlist.groupC')"
                        clearable
                        dense
                        outlined
                      ></v-select>
                    </v-flex>
                    <!-- <v-flex xs9 lg3 pa-2>
                      <v-text-field
                        hide-details
                        append-icon="mdi-account-cog-outline"
                        label="Account ID"
                        dense
                        outlined
                        color="#077893"
                        v-model="accountID"
                      ></v-text-field>
                    </v-flex> -->
                  </v-layout>
                  <v-layout row wrap justify-center align-baseline mt-n6 mb-6>
                    <v-flex xs9 lg3 pa-2>
                      <v-text-field
                        hide-details
                        append-icon="mdi-account-cog-outline"
                        label="Username"
                        dense
                        outlined
                        v-model="OneAccountID"
                        color="#077893"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        append-icon="mdi-card-text-outline"
                        :label="$t('consentlist.Idcard')"
                        color="#077893"
                        v-model="cardid"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        append-icon="mdi-passport"
                        :label="$t('NewUpdate.text4')"
                        color="#077893"
                        v-model="passport"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        append-icon="mdi-identifier"
                        :label="$t('NewUpdate.corporatenumber')"
                        color="#077893"
                        v-model="bizid"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-baseline mt-n6 mb-6>
                    <v-flex xs9 lg3 pa-2>
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        append-icon="mdi-phone-outline"
                        :label="$t('upload.tel')"
                        color="#077893"
                        v-model="phone"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2>
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        append-icon="mdi-email-outline"
                        :label="$t('upload.email')"
                        color="#077893"
                        v-model="email"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9 lg3 pa-2></v-flex>
                    <v-flex xs9 lg3 pa-2></v-flex>
                  </v-layout>
                </v-form>

                <v-layout row wrap justify-end align-end>
                  <v-flex xs12 lg3>
                    <v-btn
                      :disabled="BtnLoad"
                      block
                      dark
                      color="#077893"
                      class="white--text mr-2"
                      :loading="loadCSV"
                      @click="Fn_DownloadCSV"
                    >
                      <v-icon dark> mdi-file-excel-outline </v-icon>
                      {{ $t("search.text1") }}
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 lg2>
                    <v-btn
                      block
                      dark
                      color="#077893"
                      @click="Start_Search"
                      :loading="LoadingSearch"
                    >
                      <v-icon left> mdi-magnify </v-icon>
                      {{ $t("consentlist.search") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap justify-center ma-0 pa-2>
              <v-flex xs9 lg3 pa-4>
                <v-card outlined class="cyan lighten-5 rounded-lg">
                  <v-card-text class="pa-2 text-center black--text">
                    <p style="font-size: 18px; color: #00695c">
                      {{ $t("dashboard.all") }}
                    </p>
                    <v-chip color="#00695C" dark
                      >{{ all }} {{ $t("consentlist.list") }}</v-chip
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs9 lg3 pa-4>
                <v-card outlined class="teal lighten-5 rounded-lg">
                  <v-card-text class="pa-2 text-center black--text">
                    <p style="font-size: 18px; color: #077893">
                      {{ $t("petition.text22v2") }}
                    </p>
                    <v-chip color="#077893" dark
                      >{{ active }} {{ $t("consentlist.list") }}</v-chip
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs9 lg3 pa-4>
                <v-card outlined class="red lighten-5 rounded-lg">
                  <v-card-text class="pa-2 text-center black--text">
                    <p style="font-size: 18px; color: #803636">
                      {{ $t("policy.text3") }}
                    </p>
                    <v-chip color="#803636" dark
                      >{{ unactive }} {{ $t("consentlist.list") }}</v-chip
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs9 lg3 pa-4>
                <v-card outlined class="grey lighten-1 rounded-lg">
                  <v-card-text class="pa-2 text-center black--text">
                    <p
                      v-if="$t('default') === 'th'"
                      style="font-size: 18px; color: #000"
                    >
                      หมดอายุ
                    </p>
                    <p v-else style="font-size: 18px; color: #000">Expire</p>
                    <v-chip color="#000" dark
                      >{{ expire }} {{ $t("consentlist.list") }}</v-chip
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-data-table
              :headers="headers"
              :items="ItemUpload"
              hide-default-footer
              :page.sync="Page"
              @page-count="PageCount = $event"
              :items-per-page="ItemPerPage"
            >
              <template v-slot:[`item.SendId`]="{ item }">
                <div class="text-left">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        color="#077893"
                        style="cursor: pointer"
                        small
                        @click="Fn_CopyDetail(item.SendId)"
                        v-on="on"
                        >mdi-file-multiple-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("consentlist.copy") }}</span>
                  </v-tooltip>
                  {{ item.SendId }}
                </div>
              </template>
              <template v-slot:[`item.BusinessName`]="{ item }">
                <div v-if="$t('default') === 'th'">
                  {{ item.BusinessNameTh }}
                </div>
                <div v-else>
                  {{ item.BusinessNameEng }}
                </div>
              </template>
              <template v-slot:[`item.PolicyHeader`]="{ item }">
                {{ item.PolicyHeader }}
              </template>
              <template v-slot:[`item.SendAt`]="{ item }">
                <div v-if="$t('default') === 'th'">
                  {{ item.SendAt }}
                </div>
                <div v-else>
                  {{ item.SendAtEng }}
                </div>
              </template>
              <template v-slot:[`item.Type`]="{ item }">
                <div v-if="item.Type === 'Group'">
                  {{ $t("dashboard.groupType") }}
                </div>
                <div v-else-if="item.Type === 'General'">
                  {{ $t("dashboard.generalType") }}
                </div>
              </template>
              <template v-slot:[`item.Status`]="{ item }">
                <div v-if="item.Status === 'active'">
                  <v-chip color="green" small dark>
                    {{ $t("petition.text22v2") }}</v-chip
                  >
                </div>
                <div v-else-if="item.Status === 'unactive'">
                  <v-chip color="grey" small dark>
                    {{ $t("petition.text23") }}</v-chip
                  >
                </div>
                <div v-else-if="item.Status === 'expire'">
                  <v-chip color="black" small dark>
                    {{ $t("petition.text37") }}</v-chip
                  >
                </div>
                <div v-else>
                  <v-chip color="warning" small dark>
                    {{ $t("petition.text24") }}</v-chip
                  >
                </div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mx-2"
                      icon
                      color="info"
                      @click="FilePDF(item)"
                    >
                      <v-icon color="#077893" loading size="30">
                        mdi-eye
                      </v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </template>
            </v-data-table>
            <v-pagination
              :total-visible="7"
              class="pt-2 pb-2"
              circle
              color="#077893"
              v-model="Page"
              :length="PageCount"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            >
            </v-pagination>
          </v-card-text>
        </v-card>
      </v-flex>
      <DialogFileUpload
        :show="DialogFileUpload"
        :file="BaseUrl"
        :consentname="ConsenName"
        :filename="FileName"
        :FileType="FileType"
        @reData="FilePDF"
        @DialogCloseFileUpload="DialogFileUpload = false"
      />
    </v-layout>
    <div v-if="loadingDownloadData">
      <OverlaySearch />
    </div>
  </div>
</template>

<script>
import DialogFileUpload from "@/components/dialog/DialogFileUpload.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import { format } from "date-fns";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: { DialogFileUpload, OverlaySearch },
  data: (vm) => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    FromDate: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    ToDate: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    menu1: false,
    menu2: false,
    dark: false,
    Page: 1,
    PageCount: 0,
    ItemPerPage: 10,
    TodateMax: "",
    loadingDownloadData: false,
    LoadingSearch: false,
    status: [
      { text: "ทั้งหมด", value: "all" },
      { text: "เปิดการใช้งาน", value: "active" },
      { text: "ปิดการใช้งาน", value: "unactive" },
      { text: "หมดอายุ", value: "expire" },
    ],
    SourceStatus: "",
    Search: false,
    ItemUpload: [],
    all: "",
    active: "",
    expire: "",
    unactive: "",
    policyID: "",
    consentID: "",
    groupID: "",
    accountID: "",
    name: "",
    OneAccountID: "",
    ItemPolicy: [],
    ItemConsentGeneral: [],
    ItemConsentGroup: [],
    phone: "",
    email: "",
    cardid: "",
    passport: "",
    bizid: "",
    BaseUrl: "",
    ConsenName: "",
    FileName: "",
    FileType: "",
    DialogFileUpload: false,
    loadCSV: false,
    BtnLoad: true,
  }),
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    headers() {
      return [
        {
          text: this.$i18n.t("consentlist.Cnumber"),
          align: "center",
          value: "SendId",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("consentlist.type"),
          align: "center",
          value: "SourceSystem",
          sortable: false,
          width: "5%",
        },
        {
          text: this.$i18n.t("consentlist.topic"),
          value: "PolicyHeader",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: "ข้อมูลที่ขอ",
          value: "Tag",
          align: "center",
          sortable: false,
          width: "15%",
        },
        {
          text: this.$i18n.t("consentlist.type"),
          value: "Type",
          align: "center",
          sortable: false,
          width: "10%",
        },
        {
          text: this.$i18n.t("consentlist.date"),
          value: "SendAt",
          align: "center",
          sortable: false,
          width: "20%",
        },
        {
          text: this.$i18n.t("petition.text14"),
          value: "Status",
          align: "center",
          sortable: false,
          width: "10%",
        },
        {
          text: this.$i18n.t("consentlist.choicedetail"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
    _FromDate: {
      get() {
        if (this.FromDate === "" || this.FromDate === null) {
          return "";
        } else {
          return format(new Date(this.FromDate), "yyyyMMdd");
        }
      },
    },
    _ToDate: {
      get() {
        if (this.ToDate === "" || this.ToDate === null) {
          return "";
        } else {
          return format(new Date(this.ToDate), "yyyyMMdd");
        }
      },
    },
    _policyID: {
      get() {
        if (this.policyID === "" || this.policyID === null) {
          return "";
        } else {
          return this.policyID;
        }
      },
    },
    _consentID: {
      get() {
        if (this.consentID === "" || this.consentID === null) {
          return "";
        } else {
          return this.consentID;
        }
      },
    },
    _groupID: {
      get() {
        if (this.groupID === "" || this.groupID === null) {
          return "";
        } else {
          return this.groupID;
        }
      },
    },
    _SourceStatus: {
      get() {
        if (this.SourceStatus === "" || this.SourceStatus === null) {
          return "";
        } else {
          return this.SourceStatus;
        }
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },
  },
  mounted() {
    this.Fn_Search();
    this.Fn_GetPolicy();
    this.Fn_GetConsentGeneral();
    this.Fn_GetConsentGroup();
  },
  methods: {
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate2(date2) {
      if (!date2) return null;

      const [year, month, day] = date2.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate2(date2) {
      if (!date2) return null;

      const [month, day, year] = date2.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async Start_Search() {
      this.BtnLoad = false;
      this.Search = true;
      this.Fn_Search();
    },
    async Fn_Search() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        // AccessToken: this.$cookies.get("OneAccessToken"),
        Search: this.Search,
        FromDate: this._FromDate,
        ToDate: this._ToDate,
        ConsentId: this._consentID,
        PolicyId: this._policyID,
        GroupId: this._groupID,
        Status: this._SourceStatus,
        Name: this.name,
        OneId: this.OneAccountID,
        AccountId: this.accountID,
        Tel: this.phone,
        Email: this.email,
        IdCard: this.cardid,
        Passport: this.passport,
        BizId: this.bizid,
        Username: this.OneAccountID,
        TaxId: this._SelectTaxId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "pdf/GetLogPDF",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            // if (this.Search == false) {
            //   this.BtnLoad = false;
            // } else {
            //   this.BtnLoad = true;
            // }
            this.ItemUpload = response.data.Message.Consent;
            this.ItemUploadCount = response.data.Message.Count;
            this.all = response.data.Message.Count[0].Count;
            this.active = response.data.Message.Count[0].CountActive;
            this.expire = response.data.Message.Count[0].CountExpire;
            this.unactive = response.data.Message.Count[0].CountUnactive;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            // Toast.fire({
            //   icon: "error",
            //   title: error.message || error,
            // });
            // this.all = 0;
            // this.active = 0;
            // this.expire = 0;
            // this.unactive = 0;
          }
        });
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGeneral() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsentGeneral = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async FilePDF(val) {

      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        FileId: val.FileId,
      };

      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "pdf/GetDetailPDF",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DialogFileUpload = true;
            this.ItemFile = response.data.Message;
            this.BaseUrl = response.data.Message.File;
            this.ConsenName = response.data.Message.ConsenName;
            this.FileName = response.data.Message.FileName;
            this.FileType = response.data.Message.FileType;

          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_DownloadCSV() {
      this.loadCSV = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        // AccessToken: this.$cookies.get("OneAccessToken"),
        Search: this.Search,
        FromDate: this._FromDate,
        ToDate: this._ToDate,
        ConsentId: this._consentID,
        PolicyId: this._policyID,
        GroupId: this._groupID,
        Status: this._SourceStatus,
        Name: this.name,
        // OneId: this.OneAccountID,
        AccountId: this.$cookies.get("OneAccountId"),
        Tel: this.phone,
        Email: this.email,
        IdCard: this.cardid,
        Passport: this.passport,
        TaxId: this.bizid,
        Username: this.OneAccountID,
      };

      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "report/ExportSendUpload",
          // "http://192.168.21.60:8014/service/report/ExportSendUpload",
          { Data: dataEncode },
          { responseType: "arraybuffer", headers }
        )
        // .then((response) => {
        //   this.loadCSV = false;
        //   if (response.data) {
        //     this.ConsentDataFile = response.data;
        //     // this.Fn_LinkDownload(this.ConsentDataFile.ReportUrl);
        //   } else {
        //     Toast.fire({
        //       icon: "error",
        //       title: response.data.ErrorMessage,
        //     });
        //   }
        // })
        .then((response) => {
          this.loadCSV = false;
          if (response.statusText == "OK") {
            const blob = new Blob([response.data], {
              type: "application/xlsx",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Report_PDF" + ".xlsx";
            link.click();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadCSV = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
  watch: {
    date(val) {
      this.FromDate = this.formatDate2(this.date);
      var date = new Date(this.FromDate);
      date.setDate(date.getDate() + 90);
      this.TodateMax = date.toISOString().substr(0, 10);
    },
    date2(val) {
      this.ToDate = this.formatDate2(this.date2);
    },
    $route(to) {
      document.title = `APPLICATION_NAME - ${to.meta.title}`;
      const link = document.querySelector("[rel='icon']");
      link.setAttribute("href", to.meta.icon);
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
